/**
 * shared metadoc error helpers for ai model submission
 */
import { extractErrorMessage } from "utils/error-utils";

type ApiErrorContext = {
  status?: number;
  data?: unknown;
};

const AI_MODEL_VALIDATION_ERROR =
  "Metadoc is not valid for AI job submission: not all pages are covered by DocumentGroups";
const AI_MODEL_VALIDATION_MESSAGE =
  "Cannot run AI: not all pages are covered by Document Groups.";

export const getApiErrorContext = (error: unknown): ApiErrorContext => {
  if (typeof error === "object" && error !== null) {
    const maybeError = error as ApiErrorContext;
    return {
      status:
        typeof maybeError.status === "number" ? maybeError.status : undefined,
      data: maybeError.data,
    };
  }

  return { status: undefined, data: undefined };
};

export const getAIModelUserMessage = (error: unknown): string => {
  const message = extractErrorMessage(error, "Failed to run AI model");
  if (message.includes(AI_MODEL_VALIDATION_ERROR)) {
    return AI_MODEL_VALIDATION_MESSAGE;
  }
  return message;
};
